import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import { EditFormDetails } from "../interfaces";
import { useGetDaysOfWeekList } from "../utils";
import { TooltipLabel } from "../../components/Tooltips";

export const SelectDayOfWeek = ({
  filter,
  name,
  onChange,
  value,
  classes,
}: {
  filter: EditFormDetails;
  name?: string;
  onChange: (event: SelectChangeEvent) => void;
  value: string;
  classes: any;
}) => {
  const intl = useIntl();
  const days = useGetDaysOfWeekList();

  let inputValue;

  /**
   * In case of hardcoded option, we get null value which it represented by "-1" value in selector.
   * If no value has been selected until here (creation form)
   * or in case of mass edit with different values we display empty selector
   */
  if (value) {
    inputValue = value;
  } else if (value === null) {
    inputValue = "-1";
  } else {
    inputValue = "";
  }

  return (
    <FormControl
      className={classes.select}
      disabled={filter.readonly}
      fullWidth
      variant="outlined"
    >
      <InputLabel id="select-day-of-week-label">
        {filter.tooltip ? (
          <TooltipLabel
            label={intl.formatMessage({ id: filter.label })}
            tooltipLabel={intl.formatMessage({ id: filter.tooltip })}
            translateTooltip={false}
          />
        ) : (
          <FormattedMessage id={filter.label} />
        )}
      </InputLabel>
      <Select
        variant="outlined"
        id="select-day-of-week-select"
        labelId="select-day-of-week-label"
        name={name}
        value={inputValue}
        onChange={onChange}
      >
        <MenuItem value={-1}>
          <em>--</em>
        </MenuItem>
        {days.map(({ name, label }) => (
          <MenuItem key={name} value={name}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
